import Vue from 'vue';
import axios, { AxiosRequestConfig } from 'axios';
import { Notify } from 'vant';
import router from '@/router';
import { apis } from '@/apis';
import { Api } from '@/interface/api';
interface BadRequest {
    // http错误码
    status: number;
    // 业务错误码的常量key
    code: string;
    // 业务错误码
    errno: string;
    // 错误信息
    message: string;
    // codes.json的key
    module: string;
}

/**
 * 格式化http异常
 * @param error axios抛出的异常对象
 * @param url 请求的URL
 * @returns 标准异常
 */
function getBadReqReturn(error: any, url: string) {
    console.error(`api:${url} 接口网络错误`);
    let response: BadRequest;
    if (/Network Error/i.test(error.message)) {
        // 断网
        response = {
            status: 400,
            code: 'WEBSITE_NETWORK_ERROR',
            errno: 'E0',
            message: '网络异常，请查看网络连接',
            module: 'front_end',
        };
        Notify('网络异常，请查看网络连接');
    } else if (error.request && error.request.readyState == 4 && error.request.status == 0) {
        // 超时
        response = {
            status: 400,
            code: 'WEBSITE_NETWORK_TIMEOUT',
            errno: 'E0',
            message: '网络异常，请查看网络连接',
            module: 'front_end',
        };
        Notify('您的请求超时');
    } else {
        // 业务异常
        response = {
            status: error.response.status,
            code: error.response.data.code,
            errno: error.response.data.errno,
            message: error.response.data.message,
            module: error.response.data.module,
        };
    }
    return response;
}

const instance = axios.create({
    baseURL: `${location.origin}`,
    timeout: 300000,
});

/**
 * 封装的axios
 * @param key apis文件夹中导出的请求
 * @param params 请求参数
 * @param config 配置
 */
function $axios(key: string, params: any, dynamic = '', uploadProgress) {
    const api: Api = apis[key];
    const { url, method, uploads } = api;
    return new Promise((resolve, reject) => {
        // 参考https://element.eleme.io/#/zh-CN/component/quickstart， https://element.eleme.io/#/zh-CN/component/loading 中Loading的用法
        const isGetMethod = /^get$/i.test(method); // 判断是否是get请求
        const isDeleteMethod = /^delete$/i.test(method); // 判断是否是delete请求

        const options: AxiosRequestConfig = {
            method: method as any,
            url: url + dynamic,
        };
        if (isGetMethod || isDeleteMethod) {
            options.params = params;
        } else {
            options.data = params;
        }
        if (uploads) {
            options.headers = {
                'Content-Type': "multipart/form-data",
                ...options.headers
            }
            if(uploadProgress) {
                options.onUploadProgress = uploadProgress;
            }
        }
        instance(options)
            .then(data => {
                if (data.data.code !== 0) {
                    // resolve(data.data);
                    resolve(data)
                    return;
                }

                const error: any = new Error(data.data.code);
                error.response = data;
                throw error;
            })
            .catch(error => {
                if (error.response && error.response.status === 401) {
                    // 根据产品要求，2 秒再跳转登录
                    Notify('未登录，2 秒后跳转登录');

                    // 向主站发postMessage
                    setTimeout(() => {
                        router.push('/login');
                    }, 2000);

                    return;
                } else if(params.part && params.part == 'rankings'){
                    // Notify('B榜暂未开放');
                } else {
                    Notify((error.response && error.response.data && error.response.data.message) || '接口错误');
                }
                const response = getBadReqReturn(error, url);
                reject(response);
            });
    });
}

// 参考文档：https://cn.vuejs.org/v2/guide/typescript.html
declare module 'vue/types/vue' {
    // 3. 声明为 Vue 补充的东西
    interface Vue {
        $axios: any;
    }
}

// 参考文档：https://cn.vuejs.org/v2/guide/plugins.html#ad
Vue.use({
    install: function (Vue: any) {
        // 1. 添加全局方法或 property
        Vue.$axios = $axios;

        // 4. 添加实例方法
        Vue.prototype.$axios = $axios;
    },
});

export { $axios };
